var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFShape3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5768 69L32.1289 67.2942C16.866 49.0096 7.15326 36.5356 2.80966 26.9402C-3.46443 13.0802 2.32705 6.68329 5.16246 4.60429C10.049 0.926059 17.6503 0.712881 24.1054 4.12457C28.5093 6.47011 31.8273 11.0545 33.8182 15.6923C39.7303 3.05839 48.4175 -0.779734 54.9932 0.126496C61.9912 1.03273 66.9381 6.94988 66.9984 14.5196C67.1794 31.1516 51.6752 48.6364 37.9807 64.0424L33.5768 69ZM14.5133 4.87083C11.8588 4.87083 9.38538 5.56383 7.51522 7.00314C2.86998 10.4681 2.38735 17.2916 6.188 25.7142C10.2903 34.7232 19.3395 46.5042 33.6371 63.6692L35.085 62.0167C47.7539 47.7836 63.4994 30.0321 63.3184 14.5196C63.2581 8.60242 59.5781 3.9646 54.4502 3.2716C48.8397 2.52529 40.4542 6.84324 35.3263 21.2896L33.2149 27.2601L31.8273 21.1297C30.6811 16.1187 27.1821 9.50864 22.1749 6.84325C19.7014 5.56387 17.047 4.87083 14.5133 4.87083Z",
    fill: "#3CCFB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFShape3);
export default __webpack_public_path__ + "static/media/f-shape3.d6d8d1bf58735840b273db27ed07d802.svg";
export { ForwardRef as ReactComponent };